import React, { useState, useEffect, useRef } from 'react'
import { Button, Card, Row, Col, Tag } from 'antd'
import { useSelector } from 'react-redux'
import moment from 'moment'
import dayjs from 'dayjs'
import _ from 'lodash'
import { messageModal, modalError } from '@/utils/modalUtils'
import { getSendList, getSendTotal, reSendNfcUid, getProductAndSize, getNspExport } from '@/services/SendList/SendList'
import AntdTable from '@/components/table/AntdTable'
import SearchBar from '@/components/searchbar/SearchBar'
import ActionBar from '@/components/table/ActionBar'
import {
  numFormat,
  paginationInit,
  uniqueFun,
  uniqueResPush,
  uniqueResListPush,
  formatMessage,
  formatMessageNew,
  downLoadFileBlob,
  formatStartTime,
  formatEndTime
} from '@/utils/common'
import { hasPermission } from '@/annotations/nike-react'
import { SEND_STATUS_UPPER } from '@/utils/types'
const dateFormat = 'YYYY-MM-DD'
const dateFormat2 = 'YYYY-MM-DD HH:mm:ss'
const startMonth = dayjs().subtract(1, 'months')
const endMonth = dayjs()
const menu_nfc_report_fullTagReport = 'menu_nfc_report_fullTagReport'
let selectDropListAll = {}
const SendList = () => {
  let commonStore = useSelector(state => state.commonStore)
  let languageState = useSelector(state => state.commonStore.language)
  const mounting = useRef(false)
  let formRef = useRef(null)
  const [tableList, setTableList] = useState([])
  const [tableListTotal, setTableListTotal] = useState([])
  let searchListInit = [
    {
      type: 'input',
      label: 'NFC UID',
      key: 'nfcUid',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.commonLocale.productCode',
      key: 'productCodes',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true',
      handleChange: (e, idx, item) => {
        searchListInit.forEach(itemFirst => {
          if (itemFirst.key === 'productSizes') {
            let uniqueRes = []
            switch (itemFirst.key) {
              case 'productSizes':
                if (e && e.length > 0) {
                  e.forEach(codeItem => {
                    const selObjSizeList = selectDropListAll[codeItem]
                    uniqueRes = uniqueRes.concat(uniqueResListPush(selObjSizeList))
                  })
                } else {
                  _.forOwn(selectDropListAll, obj => {
                    uniqueRes = uniqueRes.concat(uniqueResListPush(obj))
                  })
                }
                break
              default:
                uniqueRes = []
                break
            }
            let unique = uniqueFun(uniqueRes)
            itemFirst.selectList = unique
          }
        })
        formRef && formRef.current.clearForm(['productSizes'])
        setSearchList([...searchListInit])
      }
    },
    {
      type: 'select',
      label: 'languageObj.commonLocale.productSize',
      key: 'productSizes',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.commonLocale.sendStatus',
      key: 'sendStatus',
      allowClear: true,
      initialValues: null,
      // mode: 'multiple',
      // maxTagCount: 1,
      selectList: SEND_STATUS_UPPER,
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'timeRange',
      label: 'languageObj.commonLocale.taggingDate',
      key: 'timeRange',
      format: dateFormat,
      disabledDate: current => {
        let falg =
          (current &&
            current <
              moment()
                .subtract(1, 'year')
                .subtract(1, 'day')) ||
          (current && current > moment().endOf('day'))
        return falg
      },
      initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'input',
      label: 'UPC',
      key: 'upc',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.operator',
      key: 'operator',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.workStation',
      key: 'workstation',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'timeRange',
      label: 'languageObj.commonLocale.sendDate',
      key: 'sendTime',
      format: dateFormat,
      disabledDate: current => {
        let falg =
          (current &&
            current <
              moment()
                .subtract(1, 'year')
                .subtract(1, 'day')) ||
          (current && current > moment().endOf('day'))
        return falg
      },
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const tableColumnsTotal = [
    {
      title: formatMessage(commonStore, 'languageObj.commonLocale.sendTotal'),
      dataIndex: 'totalSendLines',
      render: text => {
        return numFormat(text)
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.commonLocale.sendSuccess'),
      dataIndex: 'sendSuccess',
      render: text => {
        return <Tag color="#87d068">{numFormat(text)}</Tag>
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.commonLocale.sendFail'),
      dataIndex: 'sendFail',
      render: text => {
        return <Tag color="#f50">{numFormat(text)}</Tag>
      }
    }
  ]
  const tableColumns = [
    {
      title: formatMessage(commonStore, 'languageObj.commonLocale.productCode'),
      dataIndex: 'productCode',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.commonLocale.productName'),
      dataIndex: 'productName',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.commonLocale.productSize'),
      dataIndex: 'productSize',
      width: 70,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },

    {
      title: 'UPC',
      dataIndex: 'upc',
      width: 100,
      render: text => {
        return (
          <div className="word_break_all" style={{ minWidth: 120 }}>
            {text}
          </div>
        )
      }
    },
    {
      title: 'NFC UID',
      dataIndex: 'tagUid',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.commonLocale.sendStatus'),
      dataIndex: 'sendAntStatus',
      width: 80,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.commonLocale.operator'),
      dataIndex: 'operator',
      width: 60,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.commonLocale.workStation'),
      dataIndex: 'workstation',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.commonLocale.taggingTime'),
      dataIndex: 'taggingTime',
      width: 100,
      render: text => {
        return moment(new Date(text)).format(dateFormat2)
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.commonLocale.sendTime'),
      dataIndex: 'sendAntTime',
      width: 100,
      render: text => {
        return text && moment(new Date(text)).format(dateFormat)
      }
    }
  ]
  useEffect(() => {
    if (mounting.current) {
      searchDataFun()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  useEffect(() => {
    getSelectFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const getSelectFun = () => {
    getProductAndSize({}).then(res => {
      let resData = {
        ...res.resultData
      }
      selectDropListAll = resData
      initSearchDropList()
    })
  }
  const initSearchDropList = () => {
    try {
      let objs = selectDropListAll || {}
      searchListInit.forEach(itemFirst => {
        if (itemFirst.key === 'productCodes' || itemFirst.key === 'productSizes') {
          let uniqueRes = []
          switch (itemFirst.key) {
            case 'productCodes':
              uniqueRes = uniqueResPush(objs)
              break
            case 'productSizes':
              _.forOwn(objs, obj => {
                uniqueRes = uniqueRes.concat(uniqueResListPush(obj))
              })
              break
            default:
              uniqueRes = []
              break
          }
          let unique = uniqueFun(uniqueRes)
          itemFirst.selectList = unique
        }
      })
      setSearchList([...searchListInit])
    } catch (error) {
      console.log('filter error: ' + error)
    }
  }
  const searchDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1
    }
    mounting.current = true
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1,
      total: 0
    }
    setPagination(pg)
    setTableList([])
    setTableListTotal([])
    setSelectedRowKeys([])
    formRef && formRef.current.setValue({ timeRange: [] })
    // setQueryFlag(!queryFlag)
  }

  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const params = {
      ...info,
      nfcUid: info.nfcUid || null,
      sendStatus: info.sendStatus || null,
      productCodes: info.productCodes.length > 0 ? info.productCodes : null,
      productSizes: info.productSizes.length > 0 ? info.productSizes : null,
      taggingTimeStart: formatStartTime(info.timeRange),
      taggingTimeEnd: formatEndTime(info.timeRange),
      plantCodes: ['1025', '1027'],
      upc: info.upc || null,
      operator: info.operator || null,
      workstation: info.workstation || null,
      sendTimeStart: formatStartTime(info.sendTime),
      sendTimeEnd: formatEndTime(info.sendTime)
    }
    delete params.timeRange
    delete params.sendTime
    return params
  }

  const searchDataFun = () => {
    setSelectedRowKeys([])
    const params = {
      ...getParams(),
      size: pagination.pageSize,
      pageNo: pagination.currentPage
    }
    getSendTotal(params).then(res => {
      let dt = res.resultData
      setTableListTotal([
        {
          totalSendLines: dt.total,
          sendSuccess: dt.successCount,
          sendFail: dt.failedCount
        }
      ])
    })
    getSendList(params).then(res => {
      const dt = res.resultData
      const records = dt.records
      setTableList(records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }
  const reSendFun = () => {
    const ids = selectedRowKeys.map(item => {
      return tableList[item].tagUid
    })
    let params = ids
    reSendNfcUid(params).then(res => {
      if (res.errorCode === '200') {
        messageModal('success', {
          content: formatMessage(commonStore, 'languageObj.commonLocale.success')
        })
        setQueryFlag(!queryFlag)
        setSelectedRowKeys([])
      } else if (res.errorCode === '951') {
        const data = res.resultData
        const keys = Object.keys(data)
        let resList = keys.map(itemId => {
          return tableList.find(findItem => findItem.tagUid === itemId)
        })
        let str = resList.map(strItem => {
          return `${strItem.productCode}/${strItem.tagUid}`
        })
        modalError(
          {
            content: (
              <div>
                {formatMessageNew('languageObj.commonLocale.products')}&nbsp;{str.join('、')}&nbsp;
                {formatMessageNew('languageObj.commonLocale.resendFailed')}
              </div>
            )
          },
          () => {
            // setQueryFlag(!queryFlag)
            // setSelectedRowKeys([])
          }
        )
      }
    })
  }
  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const downLoadFun = () => {
    const params = {
      ...getParams(),
      isChinese: languageState === 'zh_CN' ? true : false
    }
    delete params.timeRange
    getNspExport(params).then(res => {
      downLoadFileBlob(res)
    })
  }
  const rowSelection = {
    selectedRowKeys,
    getCheckboxProps: record => ({
      disabled: record.sendAntStatus !== 'FAILED'
    }),
    onChange: onSelectChange
  }
  const hasSelected = selectedRowKeys.length > 0
  return (
    <Card bordered={false} bodyStyle={{ padding: 4 }}>
      <div className="search-bar">
        <SearchBar
          ref={formRef}
          searchList={searchList}
          showCollapseBtn={true}
          showSearchBtn={true}
          showClearBtn={true}
          onSearch={searchDataBtn}
          onClear={searchClearDataBtn}
        />
      </div>

      <div className="content-container">
        <Row type="flex" justify="center">
          <Col span={16}>
            <AntdTable bordered columns={tableColumnsTotal} dataSource={tableListTotal} />
          </Col>
        </Row>
        <ActionBar onDownload={downLoadFun} style={{ alignItems: 'end', marginTop: 15 }}>
          {hasPermission(menu_nfc_report_fullTagReport) ? (
            <Button type="primary" className="mr20" disabled={!hasSelected} onClick={reSendFun}>
              {formatMessage(commonStore, 'languageObj.commonLocale.resend')}
            </Button>
          ) : null}
        </ActionBar>
        {/* <div className="opt_btn mb15 mt15">
          {hasPermission(menu_nfc_report_fullTagReport) ? (
            <Button type="primary" className="mr20" disabled={!hasSelected} onClick={reSendFun}>
              {formatMessage(commonStore, 'languageObj.commonLocale.resend')}
            </Button>
          ) : null}
          <Button type="primary" disabled={tableList.length === 0} onClick={downLoadFun}>
            {formatMessage(commonStore, 'languageObj.commonLocale.download')}
          </Button>
        </div> */}
        <div>
          <AntdTable
            rowSelection={hasPermission(menu_nfc_report_fullTagReport) ? rowSelection : null}
            dataSource={tableList}
            columns={tableColumns}
            // 独一无二的标识，不能重复
            columnsKey="clcNDDCTag
            ReportColumns"
            iconTop={20}
            pagination={pagination}
            onChange={handleTableChange}
          />
        </div>
      </div>
    </Card>
  )
}
export default SendList
